import React from 'react';
import Card from '../../components/card.component';
import fixIcon from '../../assets/images/iconos/icono-021.png';

const SUPPORT_EMAIL = 'soporte@diboxapp.com';

const AccessMatenain = () => {
  return (
    <Card>
        <div className="access-denied-container">
            <div className="access-denied-box">
                <div className="denied-icon-box">
                    <img src={fixIcon} className="img-fluid" />
                </div>
                <h4>Servicio en mantenimiento</h4>
                <p className="denied-text">
                    Este servicio se encuentra temporalmente desactivado, nos encontramos realizando mejoras para que este disponible lo mas pronto posible.
                </p>
                <p className="denied-text">
                    Si tiene alguna duda puede escribir a <span>{SUPPORT_EMAIL}</span>
                </p>
            </div>
        </div>
    </Card>
  )
}

export default AccessMatenain;